import { render, staticRenderFns } from "./WikiTextBlock.vue?vue&type=template&id=e0a9a0e8"
import script from "./WikiTextBlock.vue?vue&type=script&lang=js"
export * from "./WikiTextBlock.vue?vue&type=script&lang=js"
import style0 from "./WikiTextBlock.vue?vue&type=style&index=0&id=e0a9a0e8&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports